const content = {
  glassSeals: [
    {
      step: "1",
      circleColor: "#c93e4e",
      title: "CNC Machining",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Primary CNC", "Precision CNC"],
      content: [
        "Raw materials are fed to next-gen Eurotech CNC Machines for the first round of cutting.",
        "After the first cuts are made, the parts are inspected, and additional cuts are made as needed."
      ]
    },
    {
      step: "2",
      circleColor: "#c93e4e",
      title: "Deburring",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Batch Wash", "Hand Deburring"],
      content: [
        "The batch of parts are washed, removing all machine oil, and are then deburred by in-house technicians and automated equipment."
      ]
    },
    {
      step: "3",
      circleColor: "#c93e4e",
      title: "Glass Sealing",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Palletizing", "Assembly", "Sealing"],
      content: [
        "Parts are palletized, and pins, buffers and pots are placed by hand.",
        "Once assembly is approved, parts are sent through the furnace, bonding glass-to-metal to create a hermetic seal."
      ]
    },
    {
      step: "4",
      circleColor: "#c93e4e",
      title: "Testing",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Press Test", "Leak Test", "Electrical Test"],
      content: [
        "Once sealed, parts undergo a series of rigorous tests, each tailored to ensure the part exceeds the build specifications."
      ]
    },
    {
      step: "5",
      circleColor: "#c93e4e",
      title: "Delivery",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Finishing", "Final Inspection", "Pack & Deliver"],
      content: [
        "Any finishing touches, such as plating, are completed, followed by an additional electrical test.",
        "The order is then inspected, signed, packed, and delivered by our logistics team."
      ]
    }
  ],
  precisionCNC: [
    {
      step: "1",
      title: "Custom Programming & Tooling",
      circleColor: "#c93e4e",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Tool Selection", "CNC Programming"],
      content: [
        "Each part has a custom selection of tools and CNC programs chosen, before the first cut is made."
      ]
    },
    {
      step: "2",
      circleColor: "#c93e4e",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      title: "Lathing & Milling",
      tags: ["Lathing & Milling", "Additional Cutting"],
      content: [
        "Following the pre-planning phase, materials are allocated and sent to the multi-axis lathe and milling department.",
        "After each run through the mill or lathe, the part is examined, and queued for the next round of cutting."
      ]
    },
    {
      step: "3",
      circleColor: "#c93e4e",
      title: "Wash & Deburring",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      tags: ["Batch Wash", "Deburring"],
      content: [
        "The batch of parts are washed, removing all machine oil, and are then deburred by in-house technicians and automated equipment."
      ]
    },
    {
      step: "4",
      circleColor: "#c93e4e",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      title: "Finishing",
      tags: ["Passivation", "Plating", "Dry Film Lube", "Anodizing"],
      content: [
        "Once cleaned, the parts are sent to a subcontractor for finishing.",
        "Depending on the part, they will be finished with passivation, plating, dry film lube, or in the case of aluminum parts, anodizing."
      ]
    },
    {
      step: "5",
      circleColor: "#c93e4e",
      tagColor: "#4cbbf6",
      arrowColor: "#c93e4e",
      title: "Delivery",
      tags: ["Final Inspection", "Pack & Deliver"],
      content: [
        "The order is then inspected, signed, packed, and delivered by our logistics team."
      ]
    }
  ]
};

export default content;



// WEBPACK FOOTER //
// ./src/pages/Workflow/content.js